import {
  WorkflowPublishImpactView,
  WorkflowPublishRequestView,
  WorkflowPublishResponseView,
} from "../../app/GeneratedApi";

/**
 * Changed delays with contacts waiting in them, each offered its own "move"
 * checkbox (#2350). Only when the backend says it can move them.
 */
export const getWaitingDelays = (impact: WorkflowPublishImpactView) =>
  impact.moveWaitingAvailable
    ? impact.changed.filter((node) => node.delayChanged && node.occupancy > 0)
    : [];

/**
 * The publish body: the hash and revision the customer reviewed, which the
 * backend checks against the draft (412, 9.0.009 on a mismatch), plus the
 * ticked delay nodes. moveWaitingNodeIds is only sent when something is ticked,
 * so an ordinary publish is the request a pre-#2350 backend accepts.
 */
export const buildPublishRequest = (
  reviewed: WorkflowPublishImpactView | undefined,
  moveWaitingNodeIds: string[]
): WorkflowPublishRequestView | undefined =>
  reviewed
    ? {
        expectedDraftHash: reviewed.draftHash,
        expectedRevision: reviewed.currentRevision,
        ...(moveWaitingNodeIds.length > 0 && { moveWaitingNodeIds }),
      }
    : undefined;

/** Published, but moving the waiting contacts did not start. */
export const isMoveWaitingFailure = (
  response?: WorkflowPublishResponseView | null
): boolean => response?.moveWaitingStarted === false;

/**
 * Retries a move that did not start. The draft is now the published revision,
 * so the impact report no longer lists the delay as changed and its checkbox
 * is gone; instead the same ids go on a publish that changes nothing, which
 * the backend accepts as a retry against the revision in force. The reviewed
 * hash and the revision just published still guard against an edit or another
 * publish in between (9.0.009).
 */
export const buildMoveWaitingRetryRequest = (
  reviewed: WorkflowPublishImpactView | undefined,
  published: WorkflowPublishResponseView,
  moveWaitingNodeIds: string[]
): WorkflowPublishRequestView => ({
  expectedDraftHash: reviewed?.draftHash ?? null,
  expectedRevision: published.revision,
  moveWaitingNodeIds,
});
